import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
// import AddMentor from "./pages/mentor/Add_Mentor";
// import MentorList from "./pages/mentor/Mentor_list";
// import AddBook from "./pages/books/AddBook";
// import BooksList from "./pages/books/BooksList";
import UsersList from "./pages/users/UserList";
import CareerGrowth from "./pages/careerGrowth/CareerGrowth";
import { ToastContainer } from "react-toastify";
import "react-toastify/ReactToastify.css";
// import AddEvent from "./pages/events/AddEvent";
// import EventList from "./pages/events/EventList";
// import AddCertificates from "./pages/certificates/AddCertificates";
// import CertificateList from "./pages/certificates/ListCertificates";
import PDFViewer from "./pages/books/PdfViewer";
import FrontendLogs from "./pages/users/Frontendlogs";
import VisitorLogs from "./pages/users/VisitorLogs";
import UserActivity from "./pages/users/UserActivity";
import AddTemplate from "./pages/templates/Addtemplates";
import ListTemplates from "./pages/templates/ListTemplates";
import ApproveRecruiter from "./pages/Recruiter/ApproveRecruiter";
import Layout from "./component/Layout";
import { Activity } from "./pages/UserActivity/Activity";
import PrivateRoutes from "./PrivateRoutes";
import Leads from "./pages/Leads/Leads";
import LeadsList from "./pages/Leads/Contacts";
import ContactDetails from "./pages/Leads/ContactDetails";
import AmbassadorList from "./pages/Leads/AmbassadorList";
import AmbassadorDetails from "./pages/Leads/AmbassadorDetails";
import PriceQueryList from "./pages/Leads/PriceQueryList";
import PriceQueryDetails from "./pages/Leads/PriceQueryDetails";
import AmbassadorUserList from "./pages/ambassador/AmbassadorUser";
import AIUsage from "./pages/users/TokenUsage";
import AIUsageDetails from "./pages/users/AIUsageUserDetail";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<PrivateRoutes />}>
          <Route element={<Layout />}>
            <Route index path="/" element={<Dashboard />} />
            {/* <Route path="/dashboard" element={<Dashboard />} /> */}

            {/* <Route path="/add-mentor" element={<AddMentor />} /> */}
            {/* <Route path="/mentor-list" element={<MentorList />} /> */}

            {/* Books Routes */}
            {/* <Route path="/add-book" element={<AddBook />} /> */}
            {/* <Route path="/books-list" element={<BooksList />} /> */}
            <Route path="/read-book" element={<PDFViewer />} />

            {/* template Routes */}
            <Route path="/add-templates" element={<AddTemplate />} />
            <Route path="/templatess-list" element={<ListTemplates />} />

            {/* user list */}
            <Route path="/users-list" element={<UsersList />} />
            <Route path="/career-path" element={<CareerGrowth />} />
            {/* <Route path="/users-list" element={<UsersList />} /> */}
            {/* career growth */}
            <Route path="/frontend-logs" element={<FrontendLogs />} />
            <Route path="/visiter-logs" element={<VisitorLogs />} />
            <Route path="/activity-logs" element={<UserActivity />} />

            {/* event route */}
            {/* <Route path="/add-events" element={<AddEvent />} /> */}
            {/* <Route path="/events-list" element={<EventList />} /> */}

            {/* Certificate route */}
            {/* <Route path="/add-certificate" element={<AddCertificates />} /> */}
            {/* <Route path="/certificates-list" element={<CertificateList />} /> */}
            {/* Recruiter route */}
            <Route path="/approve-recruiter" element={<ApproveRecruiter />} />
            <Route path="/user-activity" element={<Activity />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/lead-list" element={<LeadsList />} />
            <Route path="/lead-view/:id" element={<ContactDetails />} />
            <Route path="/ambassador" element={<AmbassadorList />} />
            <Route path="/ambassador/:id" element={<AmbassadorDetails />} />
            <Route path="/price-query" element={<PriceQueryList />} />
            <Route path="/price-query/:id" element={<PriceQueryDetails />} />
            <Route path="/ambassador-user" element={<AmbassadorUserList />} />
            <Route path="/token-usage" element={<AIUsage />} />
            <Route
              path="/admin/token-usage/:userId"
              element={<AIUsageDetails />}
            />

            <Route path="*" element={<Navigate to={"/"} replace={true} />} />
          </Route>
        </Route>
      </Routes>
      <ToastContainer />
    </Router>
  );
}

export default App;
